export default __webpack_public_path__ + "static/media/bm.944bbaf0.svg";